import React from "react"
import styles from "./QuantityCounter.module.scss"
import { connect } from "react-redux"

const QuantityCounter = ({
  quantity,
  customClassName,
  id,
  onSelectQuantity,
}) => {
  return (
    <div className={`${styles.container} ${customClassName}`}>
      <select
        id="quantity"
        placeholder="Project Type"
        value={!quantity ? 1 : quantity}
        onChange={e => {
          onSelectQuantity(id, parseInt(e.target.value))
        }}
      >
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
    </div>
  )
}

export default connect()(QuantityCounter)
